"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_CARD_BASE_WIDTH_MOBILE = exports.DOCUMENT_CARD_BASE_WIDTH = void 0;
exports.default = DocumentCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const useDevice_1 = require("../../hooks/useDevice");
const AppText_1 = require("../AppText");
const DocumentMenu_1 = __importDefault(require("./DocumentMenu"));
const document_2 = require("../../helper/document");
const application_host_1 = require("../../common/application-host");
const colors_1 = require("../../common/colors");
const spacing_1 = require("../../common/spacing");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const faVideo_1 = require("@fortawesome/pro-solid-svg-icons/faVideo");
exports.DOCUMENT_CARD_BASE_WIDTH = 199;
exports.DOCUMENT_CARD_BASE_WIDTH_MOBILE = 159;
function DocumentCard({ documentId, sharedDocument, onDocumentDelete }) {
    const { isMobileScreen, isTabScreen, isDesktopDevice } = (0, useDevice_1.useDevice)();
    const { navigate } = (0, native_1.useNavigation)();
    const document = (0, store_1.useAppSelector)((state) => (sharedDocument ?? (0, document_1.selectDocumentById)(state, documentId)));
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const fadeAnim = (0, react_1.useMemo)(() => new react_native_1.Animated.Value(0), []);
    const scaleAnim = (0, react_1.useMemo)(() => new react_native_1.Animated.Value(1), []);
    const tinySummary = (0, react_1.useMemo)(() => (document && ('tinySummary' in document
        ? document.tinySummary
        : (0, document_2.getMarkdownContent)(document.message, 'Tiny Summary'))), [document]);
    const imageUrl = (0, react_1.useMemo)(() => (document && ('imageUrl' in document
        ? document.imageUrl
        : (document.character.temporaryImage
            ?? document.character.documentImage
            ?? (0, application_host_1.getImageUrl)(document.character)))), [document]);
    const sourceIcon = (0, react_1.useMemo)(() => {
        if (document && 'character' in document && document.character.summary?.youtubeUrl
            || document?.files?.[0]?.sourceType === 'youtube') {
            return { icon: faVideo_1.faVideo, color: colors_1.Colors.white, bgColor: colors_1.Colors.GRADIENT_PINK };
        }
        return null;
    }, [document]);
    react_1.default.useEffect(() => {
        react_native_1.Animated.parallel([
            react_native_1.Animated.timing(fadeAnim, {
                toValue: isHovered ? 1 : 0,
                duration: 200,
                useNativeDriver: true,
            }),
            react_native_1.Animated.spring(scaleAnim, {
                toValue: isHovered ? 1.05 : 1,
                useNativeDriver: true,
            })
        ]).start();
    }, [isHovered, fadeAnim, scaleAnim]);
    const handlePress = (0, react_1.useCallback)(() => {
        if (!document) {
            return;
        }
        ;
        if ('conversation' in document) {
            navigate('Summary', { conversationId: document.conversation.id });
        }
        else {
            navigate('Summary', { shareId: document.shareId });
        }
    }, [document, navigate]);
    if (!document) {
        return;
    }
    return ((0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: handlePress, style: [
            styles.container,
            { minWidth: isMobileScreen ? exports.DOCUMENT_CARD_BASE_WIDTH_MOBILE : exports.DOCUMENT_CARD_BASE_WIDTH },
        ], onPointerEnter: () => setIsHovered(true), onPointerLeave: () => setIsHovered(false), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.menuContainer, children: (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: { opacity: isDesktopDevice && !(isMobileScreen || isTabScreen) ? fadeAnim : 1 }, children: 'shareId' in document ? ((0, jsx_runtime_1.jsx)(DocumentMenu_1.default, { sharedDocument: document, style: styles.menu })) : ((0, jsx_runtime_1.jsx)(DocumentMenu_1.default, { document: document, onDelete: onDocumentDelete, style: styles.menu })) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { source: { uri: imageUrl }, style: styles.image }) }), sourceIcon && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.sourceTag], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: sourceIcon.icon, color: sourceIcon.color, size: 14 }) })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.textContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 1, style: styles.title, children: document.character.characterName }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 2, style: [
                            styles.tinySummary,
                            isHovered && styles.tinySummaryHovered
                        ], children: tinySummary })] })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        gap: 9,
        flex: 1,
        paddingBottom: 7,
    },
    image: {
        width: '100%',
        aspectRatio: 16 / 9,
        borderRadius: 16,
    },
    textContainer: {
        gap: spacing_1.Spacing.SPACING_XS,
    },
    title: {
        color: colors_1.Colors.white,
        fontSize: 16,
        fontWeight: '500',
        lineHeight: 24,
    },
    tinySummary: {
        color: colors_1.Colors.DARK_200,
        fontWeight: '300',
        fontStyle: 'italic',
        lineHeight: 16,
    },
    tinySummaryHovered: {
        color: colors_1.Colors.DARK_100,
    },
    author: {
        color: colors_1.Colors.PRIMARY_300,
        fontSize: 12,
        lineHeight: 16,
    },
    createAccount: {
        gap: 4,
        flexDirection: 'row',
    },
    menuContainer: {
        position: 'absolute',
        top: 5,
        right: 5,
        zIndex: 1
    },
    menu: {
        position: 'relative',
    },
    sourceTag: {
        position: 'absolute',
        overflow: 'hidden',
        top: 8,
        left: 8,
        padding: 6,
        borderRadius: 8,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 28,
        minHeight: 28,
        backgroundColor: colors_1.Colors.GRADIENT_PINK[0],
        backgroundImage: `linear-gradient(to right, ${colors_1.Colors.GRADIENT_PINK[0]}, ${colors_1.Colors.GRADIENT_PINK[1]})`,
    }
});
